import React from 'react';
import { Redirect, Route } from 'react-router-dom'

import { getUser } from '../../services/UserService';

const canAccess = (roles = []) => {
  const { role } = getUser();
  return roles.some(routeRole => routeRole === role)
};

export default ({
  component: C,
  props: cProps,
  roles,
  companyTypes,
  title,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (!localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN))
        return <Redirect to={`/login?redirect=${props.location.pathname}${props.location.search}`} />

      if (!canAccess(roles, companyTypes))
        return <Redirect to={`/forbiden`} />

      document.title = `Parceiro Upgas | ${title}`;

      return <C {...props} {...cProps} />
    }}
  />
)

